// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__gMIlM","location":"Header_location__2163n"};